import { ActCode } from '../../../../shared/core/activity/domain/Act';
import { AssociatedField } from 'app/codeSpecificLogic/requiredDetails/requiredDetail.type';
import telemedicine from 'app/codeSpecificLogic/requiredDetails/Telemedicine/telemedicine';
import { chronicPainCodes } from 'shared/ramq/domainValues/codeActivityAreas';
import { RamqSpecialistActCodeNatureType } from '../../../../shared/medyx-core/types/ramq';

const addTelemedicineRequiredDetailIfNeeded = (actCode: ActCode): AssociatedField[][] => {
  if (actCode.natureType === RamqSpecialistActCodeNatureType.VISITE || chronicPainCodes.includes(actCode.code)) {
    return [telemedicine.associatedFields];
  }
  return [];
};

export default addTelemedicineRequiredDetailIfNeeded;
